export default __webpack_public_path__ + "static/media/altura.fc31e4e5.png";